// extracted by mini-css-extract-plugin
module.exports = {"stickyFooter":"StickyFooter_stickyFooter__3wFvQ","fullWidth":"StickyFooter_fullWidth__c8BsL"};